<svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
  xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" id="Calque_1" x="0px" y="0px" width="79.725998"
  height="95.518997" viewBox="0 0 79.725994 95.518996" enable-background="new 0 0 595.28 841.89" xml:space="preserve" sodipodi:docname="fut.svg"
  inkscape:version="0.92.2 (5c3e80d, 2017-08-06)">

  <defs id="defs706" />

  <g id="g701" transform="translate(-258.635,-389.032)">
    <g id="g675">
      <rect x="264.99899" y="393.42401" width="67.040001" height="88.486" id="rect673" style="fill:#ffffff" />
    </g>
    <g id="g679">
      <rect x="265.08801" y="393.42401" width="14.475" height="88.486" id="rect677" style="fill:#5c92cd"  [ngStyle]="{'fill': lightcolor}"/>
    </g>
    <g id="g683">
      <rect x="318.54001" y="393.42401" width="14.458" height="88.486" id="rect681" style="fill:#5c92cd"  [ngStyle]="{'fill': lightcolor}"/>
    </g>
    <g id="g687">
      <path d="m 335.732,394.277 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.617 0,-1.456 1.178,-2.628 2.628,-2.628 h 74.469 c 1.445,0 2.629,1.172 2.629,2.628 0,1.444 -1.183,2.617 -2.629,2.617 z"
        id="path685" inkscape:connector-curvature="0" style="fill:#284566"  [ngStyle]="{'fill': darkcolor}"/>
    </g>
    <g id="g691">
      <path d="m 335.732,418.302 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.628 0,-1.457 1.178,-2.629 2.628,-2.629 h 74.469 c 1.445,0 2.629,1.172 2.629,2.629 0,1.455 -1.183,2.628 -2.629,2.628 z"
        id="path689" inkscape:connector-curvature="0" style="fill:#284566"  [ngStyle]="{'fill': darkcolor}"/>
    </g>
    <g id="g695">
      <path d="m 335.732,463.297 h -74.469 c -1.451,0 -2.628,-1.184 -2.628,-2.629 0,-1.457 1.178,-2.629 2.628,-2.629 h 74.469 c 1.445,0 2.629,1.172 2.629,2.629 0,1.445 -1.183,2.629 -2.629,2.629 z"
        id="path693" inkscape:connector-curvature="0" style="fill:#284566"  [ngStyle]="{'fill': darkcolor}"/>
    </g>
    <g id="g699">
      <path d="m 335.732,484.551 h -74.469 c -1.451,0 -2.628,-1.172 -2.628,-2.641 0,-1.443 1.178,-2.617 2.628,-2.617 h 74.469 c 1.445,0 2.629,1.174 2.629,2.617 0,1.469 -1.183,2.641 -2.629,2.641 z"
        id="path697" inkscape:connector-curvature="0" style="fill:#284566"  [ngStyle]="{'fill': darkcolor}"/>
    </g>
  </g>
</svg>